export const MARGIN_BOTTOM = {
	auto: 'mb-auto',
	xxs: 'mb-xxs',
	xs: 'mb-xs',
	sm: 'mb-sm',
	md: 'mb-md',
	lg: 'mb-lg',
	xl: 'mb-xl',
	xxl: 'mb-xxl',
	xxxl: 'mb-xxxl',
} as const;

export type MarginBottom = keyof typeof MARGIN_BOTTOM;


export const MARGIN_RIGHT = {
	auto: 'mr-auto',
	xxs: 'mr-xxs',
	xs: 'mr-xs',
	sm: 'mr-sm',
	md: 'mr-md',
	lg: 'mr-lg',
	xl: 'mr-xl',
	xxl: 'mr-xxl',
	xxxl: 'mr-xxxl',
} as const;

export type MarginRight = keyof typeof MARGIN_RIGHT;


export const MARGIN_TOP = {
	auto: 'mt-auto',
	xxs: 'mt-xxs',
	xs: 'mt-xs',
	sm: 'mt-sm',
	md: 'mt-md',
	lg: 'mt-lg',
	xl: 'mt-xl',
	xxl: 'mt-xxl',
	xxxl: 'mt-xxxl',
} as const;

export type MarginTop = keyof typeof MARGIN_TOP;


export const MARGIN_INLINE = {
	0: 'mx-0',
	auto: 'mx-auto',
	xxs: 'mx-xxs',
	xs: 'mx-xs',
	sm: 'mx-sm',
	md: 'mx-md',
	lg: 'mx-lg',
	xl: 'mx-xl',
	xxl: 'mx-xxl',
	xxxl: 'mx-xxxl',
} as const;

export type MarginInline = keyof typeof MARGIN_INLINE;


export const MARGIN_INLINE_TABLET = {
	auto: 'tablet:mx-auto',
	xxs: 'tablet:mx-xxs',
	xs: 'tablet:mx-xs',
	sm: 'tablet:mx-sm',
	md: 'tablet:mx-md',
	lg: 'tablet:mx-lg',
	xl: 'tablet:mx-xl',
	xxl: 'tablet:mx-xxl',
	xxxl: 'tablet:mx-xxxl',
} as const;

export type MarginInlineTablet = keyof typeof MARGIN_INLINE_TABLET;


export const MARGIN_INLINE_DESKTOP = {
	auto: 'desktop:mx-auto',
	xxs: 'desktop:mx-xxs',
	xs: 'desktop:mx-xs',
	sm: 'desktop:mx-sm',
	md: 'desktop:mx-md',
	lg: 'desktop:mx-lg',
	xl: 'desktop:mx-xl',
	xxl: 'desktop:mx-xxl',
	xxxl: 'desktop:mx-xxxl',
} as const;

export type MarginInlineDesktop = keyof typeof MARGIN_INLINE_DESKTOP;


export const MARGIN_BLOCK = {
	auto: 'my-auto',
	0: 'my-0',
	xxs: 'my-xxs',
	xs: 'my-xs',
	sm: 'my-sm',
	md: 'my-md',
	lg: 'my-lg',
	xl: 'my-xl',
	xxl: 'my-xxl',
	xxxl: 'my-xxxl',
} as const;

export type MarginBlock = keyof typeof MARGIN_BLOCK;


export const MARGIN_BLOCK_TABLET = {
	auto: 'tablet:my-auto',
	0: 'tablet:my-0',
	xxs: 'tablet:my-xxs',
	xs: 'tablet:my-xs',
	sm: 'tablet:my-sm',
	md: 'tablet:my-md',
	lg: 'tablet:my-lg',
	xl: 'tablet:my-xl',
	xxl: 'tablet:my-xxl',
	xxxl: 'tablet:my-xxxl',
} as const;

export type MarginBlockTablet = keyof typeof MARGIN_BLOCK_TABLET;


export const MARGIN_BLOCK_DESKTOP = {
	auto: 'desktop:my-auto',
	0: 'desktop:my-0',
	xxs: 'desktop:my-xxs',
	xs: 'desktop:my-xs',
	sm: 'desktop:my-sm',
	md: 'desktop:my-md',
	lg: 'desktop:my-lg',
	xl: 'desktop:my-xl',
	xxl: 'desktop:my-xxl',
	xxxl: 'desktop:my-xxxl',
} as const;

export type MarginBlockDesktop = keyof typeof MARGIN_BLOCK_DESKTOP;
